import { call, put, takeLatest } from 'redux-saga/effects';

import googleDriveApi from '../../api/googleDrive';

import * as Actions from './actions';

export function* uploadFile(action) {
  let file = null;
  try {
    file = yield call(googleDriveApi.postFileToGoogleDrive, action.customerFiles);
    if (file.success) {
      yield put(Actions.fileTerminateUpload(file));
    } else {
      yield put(Actions.fileErrorUploaded());
    }
  } catch (e) {
    console.log(e, 'error');
  }
}

export function* driveListener() {
  yield takeLatest(Actions.UPLOADING_FILE_TO_GOOGLE_DRIVE, uploadFile);
}



// WEBPACK FOOTER //
// ./src/services/DriveService/saga.js